import { api } from '@packages/backend/convex/_generated/api';
import { AppVersionGate } from '@packages/shared-ui/web/app-updates';
import { useQuery } from 'convex-helpers/react';
import type { ReactNode } from 'react';
import { LoadingIcon } from '@/components/LoadingIcon';
import { env } from '@/lib/env';

/**
 * This build's `checkAppVersion` args: the CI run that deployed it (0: a build CI didn't deploy).
 * `'skip'` for development builds.
 */
const checkAppVersionInput = import.meta.env.DEV
  ? 'skip'
  : { jsVersion: Number(env.VITE_GITHUB_RUN_NUMBER ?? 0) };

/**
 * Renders the app once the update check has answered, and blocks it while its minimum JS version
 * is above this build, reloading onto the latest deploy (`AppVersionGate`). Mount above every
 * Convex subscription. A failed check renders the app.
 */
export const AppVersionGuard = ({ children }: { children: ReactNode }) => {
  const { data, isPending } = useQuery(api.adminWeb.checkAppVersion, checkAppVersionInput);

  if (checkAppVersionInput !== 'skip' && isPending) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <LoadingIcon />
      </div>
    );
  }

  return <AppVersionGate requiredUpdate={data?.requiredUpdate}>{children}</AppVersionGate>;
};
